import React, { useCallback } from 'react';
import { string, number, func, object } from 'prop-types';
import MapboxSearchBox from '../../../Mapbox/MapboxSearchBox';
import RouteDetails from '../RouteDetails';
import RouteColorRadioButtons from '../RouteColorRadioButtons';
import Button from '../../../shared/Button';
import FormButtons from '../../FormButtons';
import * as styles from './styles/styles.module.scss';
import { UPDATE_ROUTE_COLOR, CANCEL_ROUTE_FORM } from '../../../../hooks/useRoutes';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const RouteForm = ({
  distance,
  context,
  elevation,
  color,
  idx,
  dispatchRoutes,
  messagingChannel,
  handleFindLocationSelect,
  mapboxAccessToken,
  handleRouteSave,
  isSubmitting
}) => {
  const handleRouteAlterClick = useCallback(topic => {
    // fires either outAndBackClick, returnClick or reverseClick in TrailPlannerMixin to update a route
    return e => {
      messagingChannel.publish({ topic });
    };
  });

  const handleFormSubmit = e => {
    // true signifies that this save is coming from an inner form
    handleRouteSave(e, true);
  };

  const handleCancel = () => {
    dispatchRoutes({ type: CANCEL_ROUTE_FORM });
  };

  const handleColorChange = e => {
    const newColor = e.currentTarget.value;

    dispatchRoutes({ type: UPDATE_ROUTE_COLOR, payload: newColor });
    // fires handleRouteChangeColor in trail_planner_mixin to update the color on the map
    messagingChannel.publish({
      topic: 'route.edit.changeColor',
      data: newColor
    });
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleFormSubmit}>
        <h3 className={styles.routeFormHeader}>{StringConstantsMixin.strings.MAP_CREATOR.ROUTE_WITH_NUMBER(idx + 1)}</h3>
        <MapboxSearchBox
          mapboxAccessToken={mapboxAccessToken}
          languageRegionCode={context.languageRegionCode}
          handleFindLocationSelect={handleFindLocationSelect}
        />
        <div className={styles.colorDistanceSpacer}>
          <RouteDetails distance={distance} elevation={elevation} color={color} />
        </div>
        <RouteColorRadioButtons activeColor={color} onChange={handleColorChange} />
        <div className={styles.buttonsContainer}>
          <Button variant="small" onClick={handleRouteAlterClick('button.click.out_and_back')}>
            {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.OUT_AND_BACK}
          </Button>
          <Button variant="small" onClick={handleRouteAlterClick('button.click.return')}>
            {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.RETURN}
          </Button>
          <Button variant="small" onClick={handleRouteAlterClick('button.click.reverse')}>
            {StringConstantsMixin.strings.TRACK_DETAIL.ACTIONS.REVERSE}
          </Button>
        </div>
        <FormButtons onCancel={handleCancel} disabled={isSubmitting} />
      </form>
    </div>
  );
};

RouteForm.propTypes = {
  distance: string.isRequired,
  elevation: string.isRequired,
  color: string.isRequired,
  idx: number.isRequired,
  dispatchRoutes: func,
  messagingChannel: object,
  handleFindLocationSelect: func,
  mapboxAccessToken: string.isRequired
};

RouteForm.defaultProps = {
  dispatchRoutes: () => {},
  messagingChannel: {},
  handleFindLocationSelect: () => {}
};

export default RouteForm;
